import { Page } from '../graphql/generated/graphql';

export const pagePreviewItem: Page = {
  title: 'Some page title',
  path: '#',
  image: {
    data: {
      attributes: {
        url: 'https://i.picsum.photos/id/85/500/300.jpg?hmac=UGrO_uNgIXEV6mTk7PMZmPhLs3NGMhab-l27jAQMItM',
        hash: '123',
        mime: '123',
        name: 'image.jpg',
        provider: 'local',
        size: 1234,
        alternativeText: 'An image',
        caption: 'Caption for the image',
        height: 300,
        width: 500,
        previewUrl:
          'https://i.picsum.photos/id/442/30/30.jpg?hmac=fvKjsshHXyGRx0aKRaskImQCE5F1DSOPzH3xLuqxcFQ',
      },
    },
  },
  synopsis:
    "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
  tags: {
    data: [
      {
        id: '1',
        attributes: {
          label: 'Article',
          slug: 'article',
          isVisible: true,
        },
      },
      {
        id: '2',
        attributes: {
          label: 'Video',
          slug: 'video',
          isVisible: true,
        },
      },
      {
        id: '3',
        attributes: {
          label: 'How To',
          slug: 'how-to',
          isVisible: true,
        },
      },
    ],
  },
};
